var init = require("init");

init.then(function (init) {
    require("../sass/normalize.scss");
    require("@material/layout-grid/mdc-layout-grid.scss");
    require("@os/typography/typography.scss");
    require("@os/mdc/button.scss");
    require("@os/mdc/layout-grid.scss");
    require("@os/helper/helper.scss");

    require("../sass/survey-answered/survey-answered.scss");

    var templateBody = require("../view/survey-answered.hbs");

    define(["jquery", "@os/header", "@os/footer"], function (
        $,
        header,
        footer,
    ) {
        $(function () {
            $("#page-content").append(templateBody());
        });
    });
});
